import { ContainerAppUi } from '@/componentes/ContainerAppUi'
import { useRegulamentoInstituicaoGet } from '@/hooks/API/useRegulamentoInstituicaoGet'
import { useContextoOutletLayoutComNavegação } from '@/hooks/useLayoutComNavegação'
import { Loader2 } from 'lucide-react'

export const RegulamentosInstituicaoPágina = () => {
  useContextoOutletLayoutComNavegação({
    título: 'Regulamentos',
    isBotãoEsquerdo: true,
  })
  const { data } = useRegulamentoInstituicaoGet()

  return (
    <ContainerAppUi>
      {data ? (
        <div
          className='termAndPrivacy flex w-full flex-col gap-3'
          dangerouslySetInnerHTML={{
            __html: data,
          }}
        />
      ) : (
        <div className='flex w-full items-center justify-center gap-3'>
          <p className='text-base'>carregando</p>
          <Loader2 className='animate-spin' />
        </div>
      )}
    </ContainerAppUi>
  )
}
